import {
  AddBrakeEffect,
  AddSectionEffect,
  CombineSameColorSectionsEffect,
  LeechSectionSizeEffect,
  ModifyPegsAreaEffect,
  ModifyPegsEffect,
  ModifySectionScoreEffect,
  RemoveSectionEffect,
  ShrinkSectionEffect,
  SliceSectionEffect,
} from "./Effects";
import { BaseItem, ItemType, Rarity } from "./BaseItem";

/*
ItemType is used to determine what is the target of the item

  - Consumable can be used for some temp/global effects. Like getting another spin, modifying the final outcome and so on

  - Modifier can change the properties of a section

  - Section adds a new/removes a section
*/

export interface Item extends BaseItem {
  key: Items;
}

export const enum Items {
  CAR_BRAKE = "CarBrake",
  SCREW = "Screw",
  SCREW_DRIVER = "Screwdriver",
  SLEDGEHAMMER = "Sledgehammer",
  DRYWALL = "Drywall",
  COIL = "Coil",
  RIVETGUN = "Rivergun",
  NAILCLIPPER = "Nailclipper",
  STICKER = "Sticker",
  KNIFE = "Knife",
  CARJACK = "Carjack",
  BOXCUTTER = "Boxcutter",
  HOLEPUNCHER = "Holepuncher",
}

export const ItemData: { [key in Items]: Item } = {
  [Items.CAR_BRAKE]: {
    key: Items.CAR_BRAKE,
    itemType: ItemType.CONSUMABLE,
    rarity: Rarity.COMMON,
    textureKey: "items",
    frameKey: "item_brake.png",
    effects: [new AddBrakeEffect()],
    value: 4,
  },
  [Items.SCREW]: {
    key: Items.SCREW,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.COMMON,
    textureKey: "items",
    frameKey: "item_screw.png",
    effects: [new ModifyPegsEffect(1)],
    value: 2,
  },
  [Items.SCREW_DRIVER]: {
    key: Items.SCREW_DRIVER,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.COMMON,
    textureKey: "items",
    frameKey: "item_screwdriver.png",
    effects: [new ModifyPegsEffect(-1)],
    value: 2,
  },
  [Items.DRYWALL]: {
    key: Items.DRYWALL,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.COMMON,
    textureKey: "items",
    frameKey: "item_drywall.png",
    effects: [new AddSectionEffect()],
    value: 3,
  },
  [Items.SLEDGEHAMMER]: {
    key: Items.SLEDGEHAMMER,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.UNCOMMON,
    textureKey: "items",
    frameKey: "item_sledgehammer.png",
    effects: [new RemoveSectionEffect()],
    value: 6,
  },
  [Items.COIL]: {
    key: Items.COIL,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.UNCOMMON,
    textureKey: "items",
    frameKey: "item_coil.png",
    effects: [new ModifySectionScoreEffect(100)],
    value: 7,
  },
  [Items.RIVETGUN]: {
    key: Items.RIVETGUN,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.UNCOMMON,
    textureKey: "items",
    frameKey: "item_rivetgun.png",
    effects: [new ModifyPegsAreaEffect(1)],
    value: 6,
  },
  [Items.NAILCLIPPER]: {
    key: Items.NAILCLIPPER,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.UNCOMMON,
    textureKey: "items",
    frameKey: "item_nailclipper.png",
    effects: [new ModifyPegsAreaEffect(-1)],
    value: 6,
  },
  [Items.STICKER]: {
    key: Items.STICKER,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.COMMON,
    textureKey: "items",
    frameKey: "item_sticker.png",
    effects: [new ModifySectionScoreEffect(25)],
    value: 3,
  },
  [Items.KNIFE]: {
    key: Items.KNIFE,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.RARE,
    textureKey: "items",
    frameKey: "item_knife.png",
    effects: [new ShrinkSectionEffect(20)], // Shrinks section by 20%
    value: 12,
  },
  [Items.CARJACK]: {
    key: Items.CARJACK,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.RARE,
    textureKey: "items",
    frameKey: "item_carjack.png",
    effects: [new LeechSectionSizeEffect(10)], // Leeches 10% from each neighbor
    value: 12,
  },
  [Items.BOXCUTTER]: {
    key: Items.BOXCUTTER,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.RARE,
    textureKey: "items",
    frameKey: "item_boxcutter.png",
    effects: [new SliceSectionEffect()], // Slices section in half
    value: 12,
  },
  [Items.HOLEPUNCHER]: {
    key: Items.HOLEPUNCHER,
    itemType: ItemType.MODIFIER,
    rarity: Rarity.EPIC,
    textureKey: "items",
    frameKey: "item_holepuncher.png",
    effects: [new CombineSameColorSectionsEffect()], // Combines same-color neighbors
    value: 18,
  },
};
